import { useEffect, useState } from "react";
import GameManager from "../games/game-manager";
import { useSiteSettings } from "../../context/site-settings";

const BOOT_LINES = [
  "$ systemctl status emilsd-web.service",
  "● emilsd-web.service — personal site",
  "     Loaded: loaded (/etc/systemd/system/emilsd-web.service; enabled)",
  "     Active: inactive (maintenance)",
  "",
  "$ cat /etc/motd",
  "Doing some work on the site. Nothing is broken — I took it",
  "down on purpose. Check back in a bit.",
  "",
];

const MaintenancePage = () => {
  const [showGames, setShowGames] = useState(false);
  const [visibleLines, setVisibleLines] = useState(0);
  const { settings, loading } = useSiteSettings();

  // Type the log out line by line, fast enough to not be annoying.
  useEffect(() => {
    if (visibleLines >= BOOT_LINES.length) return;
    const t = setTimeout(() => setVisibleLines((n) => n + 1), 120);
    return () => clearTimeout(t);
  }, [visibleLines]);

  // If maintenance mode is switched off while someone is parked
  // here, send them back to the real site.
  useEffect(() => {
    if (!loading && !settings.maintenance_mode) {
      window.location.replace("/");
    }
  }, [loading, settings.maintenance_mode]);

  return (
    <div className="fixed inset-0 z-[9999] bg-black text-white font-mono flex items-center justify-center p-4">
      <a
        href="/admin"
        className="absolute top-4 right-4 px-4 py-2 border border-white/20 text-white/60
                   hover:border-white/40 hover:text-white transition-colors text-sm"
      >
        admin login
      </a>

      <div className="w-full max-w-2xl border border-white/20">
        {/* Terminal title bar */}
        <div className="flex items-center justify-between border-b border-white/20 px-3 py-2">
          <span className="text-sm text-white/70 bg-white/10 px-2 py-0.5">
            emil@emilsd-web.org: /var/www
          </span>
          <span className="text-white/40 text-sm">maintenance</span>
        </div>

        {/* Terminal body */}
        <div className="p-6 text-sm leading-relaxed min-h-[16rem]">
          {BOOT_LINES.slice(0, visibleLines).map((line, i) => (
            <div
              key={i}
              className={
                line.startsWith("$")
                  ? "text-white"
                  : line.startsWith("●")
                    ? "text-white/90"
                    : "text-white/60"
              }
            >
              {line || "\u00A0"}
            </div>
          ))}

          {visibleLines >= BOOT_LINES.length && (
            <div className="mt-2">
              <button
                onClick={() => setShowGames(true)}
                className="text-left text-white/80 hover:text-white hover:bg-white/10
                           transition-colors px-1 -mx-1"
              >
                $ ./arcade{" "}
                <span className="text-white/40"># kill time while you wait</span>
              </button>
              <div className="flex items-center text-white/80 mt-1">
                <span>$&nbsp;</span>
                <span className="w-2.5 h-4 bg-white/80 animate-pulse" />
              </div>
            </div>
          )}
        </div>

        {/* Terminal footer */}
        <div className="border-t border-white/20 px-3 py-2 text-xs text-white/40 flex justify-between">
          <span>ETA: soon™</span>
          <span>exit code 0</span>
        </div>
      </div>

      <GameManager isOpen={showGames} onClose={() => setShowGames(false)} />
    </div>
  );
};

export default MaintenancePage;
